module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-header-tesla-placeholder-1440x900-act.48099b5c.jpg";